import React  from 'react'
import { Button,Form,Input,DatePicker, Select,} from 'antd'
import GetUserDept from '../../cpn/GetUserDept';
import GetClient from '../client/GetClient';
import GetSalesman from './GetSalesman';
import GetGroupNum from './GetGroupNum';
import GetOperator from './GetOperator';
import dayjs from 'dayjs';
const {RangePicker} = DatePicker
function LedgerQuery(props) {
    const [form] = Form.useForm();   
    return (
        <Form
            form={form}
            layout="inline"
            name="form_in_modal"
            initialValues={{modifier: 'public',}}
            onFinish={(values) => {
                props.getQuery({
                    action:"search",
                    ebn_dept_id:values.ebn_dept_id,
                    ebn_client_id:values.ebn_client_id,
                    ebn_uid:values.ebn_uid,
                    ebn_team_num:values.ebn_team_num,
                    ebn_date_s:values.ebn_date_s?dayjs(values.ebn_date_s[0]).format('YYYY-MM-DD'):'',
                    ebn_date_e:values.ebn_date_s?dayjs(values.ebn_date_s[1]).format('YYYY-MM-DD'):'',
                    ebn_ctime:values.ebn_ctime?dayjs(values.ebn_ctime).format('YYYY-MM-DD'):'',
                    ebn_content:values.ebn_content,
                    ebn_yw_id:values.salesman,                                
                })
                localStorage.setItem('ebn_query_dept',values.ebn_dept_id?JSON.stringify(values.ebn_dept_id):JSON.stringify(''))
                localStorage.setItem('ebn_query_client',values.ebn_client_id?JSON.stringify(values.ebn_client_id):JSON.stringify(''))
                localStorage.setItem('ebn_query_uid',values.ebn_uid?JSON.stringify(values.ebn_uid):JSON.stringify(''))
                localStorage.setItem('ebn_query_team_num',values.ebn_team_num?JSON.stringify(values.ebn_team_num):JSON.stringify(''))
                localStorage.setItem('ebn_query_date_s',values.ebn_date_s?JSON.stringify(values.ebn_date_s[0]):'')
                localStorage.setItem('ebn_query_date_e',values.ebn_date_s?JSON.stringify(values.ebn_date_s[1]):'')
                localStorage.setItem('ebn_query_dateNew',values.ebn_ctime?JSON.stringify(values.ebn_ctime):JSON.stringify(''))
                localStorage.setItem('ebn_query_ec_content',values.ebn_content?JSON.stringify(values.ebn_content):JSON.stringify(''))
                localStorage.setItem('ebn_query_yw_id',values.salesman?JSON.stringify(values.salesman):JSON.stringify(''))
                localStorage.setItem('ebn_query_action',JSON.stringify('search'))
            }}
        >                                
            <GetUserDept  
                label='部门' 
                wrapperCol={{span:15}}
                getUserDept={(e) => {}}
                name='ebn_dept_id'
                selectAll='true'
                initialValues={JSON.parse(localStorage.getItem('ebn_query_dept') || '""')}
                style={{width:"120px"}}
                setDept={true}
                FormStyle={{width:"170px"}}
                labelCol={{span:8}}
            />
            <GetClient 
                label='客户'
                getClient={(e) => {}}  
                name='ebn_client_id'
                style={{width:'140px'}}
                initialValues={JSON.parse(localStorage.getItem('ebn_query_client') || '""')}
                setClient={true}
                FormStyle={{marginBottom:"0",width:"180px"}}
                labelCol={{span:6}}
            />
            <GetOperator 
                label='操作员'
                wrapperCol={{span:14}} 
                getOperator={(e) => {}} 
                name='ebn_uid'
                style={{width:'90px'}}
                labelCol={{span:10}}
                formStyle={{width:'140px'}}
            />                                 
            <GetSalesman 
                label='销售员' 
                name='salesman' 
                getSalesman={(e) => {}}
                wrapperCol={{span:12}} 
                style={{width:'90px'}}
                labelCol={{span:12}}
                formStyle={{width:'120px'}}
            />
            <GetGroupNum 
                label='团号' 
                wrapperCol={{span:18}} 
                getGroupNum={(e) => {}}
                name='ebn_team_num'
                initialValues={JSON.parse(localStorage.getItem('ebn_query_team_num') || '""')}
                style={{width:'150px'}}
            />
            <Form.Item 
                name="ebn_date_s" 
                label='出发' 
                labelCol={{span:4}} 
                style={{width:'240px'}}
                wrapperCol={{span:18}}
            >
                <RangePicker style={{width:'220px'}}  />                                                 
            </Form.Item>
            <Form.Item 
                name="ebn_ctime" 
                label='新增'  
                style={{width:'160px'}} 
                labelCol={{span:8}}
                wrapperCol={{span:14}}
            >
                <DatePicker style={{width:'120px'}} />                                                  
            </Form.Item>
            <Form.Item 
                name="ebn_content" 
                label='备注' 
                wrapperCol={{span:18}} 
                style={{width:'130px'}}
                labelCol={{span:6}}
            >
                <Input style={{width:"110px"}}/>
            </Form.Item>
            <Form.Item 
                name="status" 
                wrapperCol={{span:15}} 
                style={{width:'70px'}} 
                initialValue={'all'}
            >
                <Select                     
                    style={{width:'100px'}}
                    options={[
                        {
                            label:"全部状态",
                            value:'all'
                        },
                        {
                            label:"未出发",
                            value:"notStart"
                        },
                        {
                            label:"已出发",
                            value:"started"
                        },
                        {
                            label:"已审核",
                            value:"auditOne"
                        },
                        {
                            label:"已复核",
                            value:"auditTwo"
                        },
                    ]}
                    onChange={(e) => {
                        props.getStatus(e)
                    }}
                />
            </Form.Item>  
            <Form.Item
                style={{width:'65px'}}
            >
                <Button  
                    style={{marginLeft:"15px"}} 
                    htmlType='submit'
                >查询</Button>   
            </Form.Item>                                                          
            <Form.Item style={{width:'65px'}}>
                <Button onClick={() => {    
                    localStorage.setItem('ebn_query_dept',JSON.stringify(''))
                    localStorage.setItem('ebn_query_client',JSON.stringify(''))
                    localStorage.setItem('ebn_query_uid',JSON.stringify(''))
                    localStorage.setItem('ebn_query_team_num',JSON.stringify(''))
                    localStorage.setItem('ebn_query_date_s',JSON.stringify(''))
                    localStorage.setItem('ebn_query_date_e',JSON.stringify(''))
                    localStorage.setItem('ebn_query_dateNew',JSON.stringify(''))
                    localStorage.setItem('ebn_query_ec_content',JSON.stringify(''))
                    localStorage.setItem('ebn_query_yw_id',JSON.stringify(''))                                    
                    localStorage.setItem('ebn_query_action',JSON.stringify(''))                                    
                    form.resetFields();
                    props.getQuery({action:'',ebn_query_dept:'',ebn_query_client:'',ebn_query_uid:'',ebn_query_team_num:'',ebn_query_date_s:'',ebn_query_date_e:'',ebn_query_dateNew:'',ebn_query_ec_content:'',ebn_query_yw_id:''})  
                    props.getStatus('all')
                    }}>重置</Button>   
            </Form.Item>                                                          
        </Form>
    )
}

export default LedgerQuery